"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StockText = exports.StockIndicator = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'start',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1)
}));
const StockIndicator = exports.StockIndicator = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOutOfStock,
  theme
}) => ({
  backgroundColor: isOutOfStock ? theme.palette.error.dark : theme.palette.success.main,
  borderRadius: '50%',
  flexShrink: 0,
  height: 8,
  marginTop: 7,
  width: 8
}));
const StockText = exports.StockText = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOutOfStock,
  theme
}) => ({
  color: isOutOfStock ? theme.palette.error.dark : theme.palette.text.secondary
}));